import { render, staticRenderFns } from "./AddNFT.vue?vue&type=template&id=3bffc092&scoped=true&"
import script from "./AddNFT.vue?vue&type=script&lang=js&"
export * from "./AddNFT.vue?vue&type=script&lang=js&"
import style0 from "./AddNFT.vue?vue&type=style&index=0&id=3bffc092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffc092",
  null
  
)

export default component.exports